<script setup lang="ts">
import type { FlightProductCardData } from '../../../models';

import FlightProductCardContent from './FlightProductCardContent.vue';

interface FlightProductCardProps {
  productCardData: FlightProductCardData;
  printMode: boolean;
  shouldHideProductLink: boolean;
}

const props = defineProps<FlightProductCardProps>();

interface FlightProductCardEmits {
  (event: 'show-details'): void;
  (eventName: 'change-flight'): void;
  (eventName: 'remove-flight'): void;
}

const emit = defineEmits<FlightProductCardEmits>();

function showDetails(): void {
  if (!props.printMode) {
    emit('show-details');
  }
}

function showDetailsOnCardClick(): void {
  if (!props.shouldHideProductLink) {
    showDetails();
  }
}
</script>

<template>
  <div
    class="flight-product-card"
    :class="{
      'print-mode': props.printMode,
      test: props.shouldHideProductLink,
    }"
    @click="showDetailsOnCardClick"
  >
    <FlightProductCardContent
      :product-card-content="props.productCardData"
      :should-hide-product-link="props.shouldHideProductLink"
      :print-mode="props.printMode"
      @show-details="showDetails"
      @change-flight="emit('change-flight')"
      @remove-flight="emit('remove-flight')"
    />
  </div>
</template>

<style scoped lang="scss">
.flight-product-card {
  background: var(--color-white);
  border: 1px solid var(--color-neutral-30);
  border-radius: var(--border-radius-8);
  overflow: hidden;

  &:not(.print-mode, .test) {
    @include on-hover {
      background: var(--color-neutral-30);
      transition: background var(--transition-short);
      cursor: pointer;
    }
  }
}
</style>
